import i18n from "../../i18n"

const listStatusEmployees = [
  {
    label: i18n.t("ACTIVE"),
    value: "ACTIVE"
  },
  {
    label: i18n.t("INACTIVE"),
    value: "INACTIVE"
  }
]

export { listStatusEmployees }